import { useEffect, useState } from 'react'

export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
}

const THEME_STORAGE_KEY = 'platformTheme'
const THEME_CHANGE_EVENT = 'platform-theme-change'

const getSavedTheme = () => {
  if (typeof window === 'undefined') {
    return THEME_MODES.LIGHT
  }

  return localStorage.getItem(THEME_STORAGE_KEY) === THEME_MODES.DARK
    ? THEME_MODES.DARK
    : THEME_MODES.LIGHT
}

const applyTheme = (theme) => {
  if (typeof document === 'undefined') {
    return
  }

  document.documentElement.dataset.theme = theme
}

export const useThemeMode = () => {
  const [theme, setTheme] = useState(getSavedTheme)

  useEffect(() => {
    applyTheme(theme)
    localStorage.setItem(THEME_STORAGE_KEY, theme)
  }, [theme])

  useEffect(() => {
    const handleThemeChange = (event) => {
      setTheme(event.detail?.theme || getSavedTheme())
    }

    window.addEventListener(THEME_CHANGE_EVENT, handleThemeChange)

    return () => {
      window.removeEventListener(THEME_CHANGE_EVENT, handleThemeChange)
    }
  }, [])

  const toggleTheme = () => {
    const nextTheme =
      theme === THEME_MODES.DARK ? THEME_MODES.LIGHT : THEME_MODES.DARK

    setTheme(nextTheme)
    window.dispatchEvent(
      new CustomEvent(THEME_CHANGE_EVENT, { detail: { theme: nextTheme } }),
    )
  }

  return {
    theme,
    isDarkTheme: theme === THEME_MODES.DARK,
    toggleTheme,
  }
}

applyTheme(getSavedTheme())
